import { useMe } from './useMe';
import type { PermissionLevel } from './types';

// Reads the caller's server-resolved PermissionSet from /me - the same object the backend
// enforces with - so every gate in the SPA mirrors a real server rule instead of hard-coding
// role checks. Impersonation is already folded in (the server resolves the EFFECTIVE role).
// Every helper fails closed while /me is loading or a key is absent.
export function usePermissions() {
  const meQuery = useMe();
  const permissions = meQuery.data?.permissions;
  const admin = permissions?.admin ?? false;

  function tabPermission(tabCode: string): PermissionLevel {
    return permissions?.tabs[tabCode] ?? 'NO_ACCESS';
  }

  return {
    isLoading: meQuery.isLoading,
    isAdmin: admin,
    canView: (tabCode: string) => admin || tabPermission(tabCode) !== 'NO_ACCESS',
    canEdit: (tabCode: string) => admin || tabPermission(tabCode) === 'EDIT',
    moduleEnabled: (key: string) => admin || (permissions?.modules[key] ?? false),
  };
}
